(function () {
    // Initialize per .faqs block to avoid cross-talk when multiple blocks exist on a page.
    $(function () {
        $('.faqs').each(function () {
            const $block = $(this);
            const $tabs = $block.find('.faq_tab');
            const $groups = $block.find('.faq');

            function showFaqInBlock(tabId) {
                // remove active on tabs within this block only
                $tabs.removeClass('active-faq');
                // hide all groups in this block
                $groups.hide();
                // show the target group
                $block.find(`#${tabId}`).show();
                // mark the clicked tab active
                $block.find(`[data-tab="${tabId}"]`).addClass('active-faq');
            }

            // wire up tab clicks
            $tabs.on('click', function (e) {
                e.preventDefault();
                const tabId = $(this).data('tab');
                if (!tabId) return;
                showFaqInBlock(tabId);
            });

            // initialize: hide all groups then show the first one (if any)
            $groups.hide();
            const $firstGroup = $groups.first();
            if ($firstGroup.length) {
                const firstId = $firstGroup.attr('id');
                if (firstId) showFaqInBlock(firstId);
            }

            // Accordion behaviour scoped to this block: close other accordions within the same block
            $block.find('.accordion summary').on('click', function () {
                const $currentAccordion = $(this).parent();
                $block.find('.accordion').not($currentAccordion).removeAttr('open');
            });
        });
    });
})();

